import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";
import SectionTitle from "../atoms/SectionTitle";

// Title 기준 왼쪽
const Section = styled.section`
    display: flex;
    margin-top: 60px;
    margin-bottom: 140px;
    align-items: center;
    width: 100%;

    ${device.tablet} {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: 100px;
        padding: 0 20px;
        margin-bottom: 80px;
        font-size: 1.5rem;
    }

    ${device.mobile} {
        flex-direction: column-reverse;
        align-items: flex-start;
        margin-bottom: 30px;
        margin-top: 0;
    }

`;
const TextBox = styled.div`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.4px;
    word-break: keep-all;
    white-space: pre-wrap;

    ${device.tablet} {
        width: 100%;
        max-width: 700px;
        letter-spacing: -0.4px;
        font-weight: 400;
        font-size: 16px;
        word-break: keep-all;
    }

    ${device.mobile} {
        width: 100%;
        max-width: 100vw;
        letter-spacing: -0.4px;
        line-height: 2;
        margin-bottom: 50px;
        font-weight: 400;
        font-size: 14px;
        word-break: keep-all;
        white-space: pre-wrap;
    }
`;
const InfoList = styled.ul`
    margin-top: 10px;
    word-break: keep-all;
    ${device.tablet} {
        margin-top: 40px;
        line-height: 2.3rem;
        word-break: keep-all;
    }
`;
const Item = styled.li`
    ${device.tablet} {
        font-size: 1.3rem;
        line-height: 2.3rem;
        word-break: keep-all;
    }
`;

const RightBox = styled.div`
    width: 40%;
    ${device.tablet} {
        width: 100%;
    }
    ${device.mobile} {
        width: 100%;
    }
`;

const LeftBox = styled.div`
    display: flex;
    position: relative;
    justify-content: left;
    width: 60%;

    div:first-child {
        position: absolute;
        top: ${({top}) => top ? top : "251px"};
        z-index: 2;
        right: 110px;

        img {
            width: 100%;
            max-width: 432px;
            height: auto;
            z-index: 2;
            display: block;
        }
    }

    div:last-child {

        position: relative;

        &:hover {
            z-index: 2;
            position: relative;
        }

        img {
            width: 100%;
            max-width: 435px;
            height: 650px;
            object-fit: cover;
            display: block;
        }
    }

    ${device.tablet} {
        width: 100%;
        flex-direction: row-reverse;

        div:first-child {
            flex: 2;
            position: relative;
            left: -30px;
            top: 50px;

            img {
                width: 100%;
                z-index: 2;
            }
        }

        div:last-child {
            flex: 2;
            right: 0;
            position: relative;
            width: 100%;

            &:hover {
                position: relative;
            }

            img {
                width: 100%;
                height: auto;
            }
        }
    }

    ${device.mobile} {
        width: 100%;

        div:first-child {
            position: absolute;
            right: 0;
            top: 50px;
            width: 50%;

            img {
                z-index: 2;
            }
        }

        div:last-child {
            right: 0;
            position: relative;
            width: 55%;

            &:hover {
                position: relative;
                z-index: 10;
            }

            img {
                height: auto;
            }
        }
    }
`;
const ImgBox = styled.div``;
const Img = styled.img``;

const SimbolTarget = styled.div`
    padding-top: 140px;
    width: 1px;
    height: 1px;
    display: block;

    ${device.tablet} {
        padding-top: 0;
    }

    ${device.mobile} {
        padding-top: 0;
    }
`;


const RightSection = ({
                          title, enTitle, subTitle, textList, list, img1,
                          top, left, img2, simbol,
                          simbolId, content
                      }) => {
    return (
        <>
            <Section>
                <LeftBox top={top} left={left}>
                    <ImgBox> <Img src={img1}/></ImgBox>
                    <ImgBox> <Img src={img2}/></ImgBox>
                </LeftBox>

                <RightBox>
                    {title && <SectionTitle
                        title={title}
                        enTitle={enTitle}
                        subTitle={subTitle}/>}
                    <TextBox>
                        {textList}
                        {/*{textList && textList.map((text, index) => (*/}
                        {/*    <Txt key={index}>{text}</Txt>*/}
                        {/*))}*/}
                        {list && <InfoList>
                            {list && list.map((item, index) => (<Item key={index}>{item}</Item>))}
                        </InfoList>}
                        {content}
                    </TextBox>
                </RightBox>

            </Section>

            {simbol && <SimbolTarget id={simbolId}/>}

        </>
    );
};

export default RightSection;
